import EventBus from '@/scripts/event-bus';

export const EXIT_SURVEY_RESPONSE_DETAILS_WIDGET_NAME = 'exit-survey-response-details-widget';

export function openExitSurveyResponseDetailsWidget(config) {
    return EventBus.$emit('open-widget', {
        name: EXIT_SURVEY_RESPONSE_DETAILS_WIDGET_NAME,
        config: {
            responseType: config.responseType,
            dateRange: config.dateRange,
        },
    });
}
